import { render, staticRenderFns } from "./checkarea.vue?vue&type=template&id=f1fbf8a6&scoped=true&"
import script from "./checkarea.vue?vue&type=script&lang=js&"
export * from "./checkarea.vue?vue&type=script&lang=js&"
import style0 from "./checkarea.vue?vue&type=style&index=0&id=f1fbf8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fbf8a6",
  null
  
)

export default component.exports